import React from 'react';
import { Empty, Flex, Skeleton, Typography } from 'antd';

const FilterSection = ({ header, isFilterLoading, children, options }) => {
  return (
    <Flex vertical gap={7} flex={1}>
      <Typography.Text type="secondary" className="filter-section-header">
        {header}
      </Typography.Text>
      <Flex vertical gap={7} align="center" className="filter-pill-container">
        {options?.length <= 0 && !isFilterLoading && (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}

        {isFilterLoading && (
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 4, width: [150, 150, 100, 80] }}
          />
        )}

        {options?.length > 0 && !isFilterLoading && children}
      </Flex>
    </Flex>
  );
};

export default FilterSection;
